export default {"src":"/_next/static/media/Ethereum.26b9fa7d.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};